/**
 * WORLD-CUP-VIRAL-ACTIVATION-P0 — small reusable CTA that links to the
 * already-built VictoryCardsHub page (`/viral-cards`). Surfaced from
 * PremiumGoalCelebration, NationOvertakeToast, PredictionCard correct
 * vote, and DailyWowSplash. Pure link, no new engine.
 */
import { Link } from "@tanstack/react-router";
import { Sparkles } from "lucide-react";
import { trackEvent } from "@/lib/audit";

interface Props {
  source: string;
  label?: string;
  compact?: boolean;
}

export function VictoryCardCta({ source, label = "Compartir mi resultado", compact = false }: Props) {
  return (
    <Link
      to="/viral-cards"
      onClick={() => void trackEvent("victory_card_cta_clicked", { source })}
      className={`pointer-events-auto inline-flex items-center gap-1.5 rounded-full border border-primary/50 bg-primary/20 px-3 ${compact ? "py-1 text-[10px]" : "py-1.5 text-[11px]"} font-black uppercase tracking-wider text-foreground shadow-md hover:bg-primary/30 transition`}
      aria-label={label}
    >
      <Sparkles className="h-3 w-3" />
      {label}
    </Link>
  );
}